import { get } from 'lodash'

const getSourceSetupOption = (state, option) =>
  get(state, `application.sourceSetup.${option}`)

export const getSourceSetupStep = state => getSourceSetupOption(state, 'step')

export const getSourceSetupSlug = state =>
  getSourceSetupOption(state, 'sourceSlug')

export const getSourceSetupOauthError = state =>
  getSourceSetupOption(state, 'oauthError')

export const getSourceSetupSource = state =>
  getSourceSetupOption(state, 'source')

export const getSourceSetupSettings = state =>
  getSourceSetupSource(state).settings

export const isSourceSetupConnectSuccessful = state => {
  const oauthError = getSourceSetupOauthError(state)
  const settings = getSourceSetupSettings(state)
  return Boolean(!oauthError && settings)
}

export function getNextSourceSetupStep(state, sourceMetadata) {
  const currentStep = getSourceSetupStep(state)
  let nextStep

  if (currentStep === 'connect') {
    if (get(sourceMetadata, 'features.accounts')) {
      nextStep = 'select-account'
    } else {
      nextStep = 'test-connection'
    }
  } else if (currentStep === 'select-account') {
    nextStep = 'test-connection'
  } else if (currentStep === 'test-connection') {
    nextStep = 'warehouse-config'
  } else if (currentStep === 'warehouse-config') {
    nextStep = 'connected'
  }

  return nextStep
}
